import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, useTheme } from '@mui/material'
import React from 'react'
import { PaymentState } from '../../services/api/sharedTypes/Common'
import { convertPaymentStateTypeToString, convertStringToPaymentState } from '../../utils/event-utils'

interface PaymentSelectProps {
    paymentState: PaymentState | undefined
    onChange: (paymentState: PaymentState | undefined) => void
    /**
     * IsInvoiced - If event have invoice
     * If true, the Paid option is available, otherwise the PaidWithoutInvoice option is available
     * @default false
     */
    isInvoiced?: boolean
    isSmall?: boolean
}

const PaymentSelect: React.FC<PaymentSelectProps> = ({ paymentState, onChange, isInvoiced, isSmall }: PaymentSelectProps) => {
    const theme = useTheme()

    const handlePaymentSelectChange = (eventChange: SelectChangeEvent<PaymentState>) => {
        const {
            target: { value },
        } = eventChange
        onChange(typeof value === 'string' ? convertStringToPaymentState(Number(value)) : value)
    }

    return (
        <FormControl size='small' fullWidth>
            <InputLabel>Stav platby</InputLabel>
            <Select
                value={paymentState}
                onChange={handlePaymentSelectChange}
                input={<OutlinedInput label='Stav platby' style={{ background: theme.palette.customBackground.default, maxHeight: isSmall ? 36 : 'unset' }} />}
                renderValue={(selected) => convertPaymentStateTypeToString(convertStringToPaymentState(Number(selected)))}
            >
                <MenuItem value={PaymentState.NotPaid}>Nezaplaceno</MenuItem>
                {isInvoiced ? (
                    <MenuItem value={PaymentState.Paid}>Zaplaceno</MenuItem>
                ) : (
                    <MenuItem value={PaymentState.PaidWithoutInvoice}>Zaplaceno</MenuItem>
                )}
                <MenuItem value={PaymentState.Free}>Zadarmo</MenuItem>
                <MenuItem value={PaymentState.NotSet}>Beze stavu</MenuItem>
            </Select>
        </FormControl>
    )
}

export default PaymentSelect
